import { z } from "zod";

/**
 * Query for `GET /v1/cede-arena/campaign-account-pnls`. Paper accounts are
 * per-(user, campaign), so the campaign name alone keys the read (a duel is
 * single-epoch, so this is the epoch's PnL).
 */
export const CedeArenaCampaignAccountPnlsQuerySchema = z.object({
  campaign: z.string(),
});

export type CedeArenaCampaignAccountPnlsQueryDto = z.infer<typeof CedeArenaCampaignAccountPnlsQuerySchema>;

/**
 * One participant's REAL account PnL (realized + unrealized, USD) for an arena
 * competition — sourced from the paper-trading account, NOT the leaderboard
 * `score` (which is a normalized ranking scale, not dollars).
 */
export const ArenaAccountPnlSchema = z.object({
  hubUserId: z.number().int(),
  /** Realized + unrealized PnL in USD, as a decimal string (the FE converts to a number for display). */
  pnlUsd: z.string(),
});

/**
 * Per-account real PnL for an arena campaign — the credibility surface behind
 * Watch Live's live and settled rows.
 */
export const ArenaCampaignAccountPnlsSchema = z.object({
  pnls: z.array(ArenaAccountPnlSchema),
});

export type ArenaCampaignAccountPnlsDto = z.infer<typeof ArenaCampaignAccountPnlsSchema>;
